"use client";

const imageLoader = ({ src, width, quality }: any) => {
  return `${process.env.NEXT_PUBLIC_IMG_URL}/${src.slice(7)}?v=1&w=${width}&q=${quality || 75}`;
};

export default imageLoader;
